export const DATE_FORMATS = {
    FULL_DATE: "dd/MM/yyyy",
    MONTH_YEAR_DATE: "MMM yyyy",
    MONTH_ABBREVIATED: "MMM",
    DISPLAY_DATE: "dd MMM yyyy",
    FRIENDLY_DATE: "EEE, d MMM",
    ISO_YMD: "yyyy-MM-dd",
    FULL_MONTH_YEAR: "MMMM yyyy",
};

export const TIME_FORMATS = {
    FULL_TIME: "HH:mm",
};

export const HALF_HOUR_MINUTES = ["00", "30"];

export const MONTHS = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

/**
 * Constant for one day in milliseconds
 */
export const ONE_DAY_MS = 24 * 60 * 60 * 1000;

/**
 * Constant for three hours in milliseconds (Dashboard customer/admin threshold)
 */
export const THREE_HOURS_MS = 3 * 60 * 60 * 1000;